import { Text, theme } from '@socrait/react';
import { Linking, StyleSheet } from 'react-native';

import { HyperLink } from '~/components/HyperLink';

import { useSparkUpsellLink } from '~/featureFlags';

const styles = StyleSheet.create({
  text: {
    fontSize: theme.fontSizes.xsmall,
    lineHeight: theme.lineHeights.small,
  },
});

export function SparkTooltipContent() {
  const upsellLink = useSparkUpsellLink();

  return (
    <Text style={styles.text}>
      To enable more filters and see more data, ask your school about getting a Socrait site license.{' '}
      {!!upsellLink && (
        <Text style={styles.text}>
          For more information, click{' '}
          <HyperLink onPress={() => Linking.openURL(upsellLink)} style={styles.text}>
            here
          </HyperLink>
          .
        </Text>
      )}
    </Text>
  );
}
